import { render, staticRenderFns } from "./RequestQuoteButton.vue?vue&type=template&id=48994d00&scoped=true&"
import script from "./RequestQuoteButton.vue?vue&type=script&lang=ts&"
export * from "./RequestQuoteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48994d00",
  null
  
)

export default component.exports